/* TheStudiz – "Recently viewed" books. localStorage + /products/<handle>.js. Koi observer nahi. */
(function () {
  var KEY = 'ts_recently_viewed';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR';
    return (cur === 'PKR' ? 'Rs.' : cur + ' ') + Math.round(cents / 100).toLocaleString('en-US');
  }

  function init(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = 'true';
    var current = box.dataset.current || '';
    var limit = parseInt(box.dataset.limit, 10) || 6;
    var list = read();
    if (current) {
      list = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 12);
      write(list);
    }
    var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var ul = box.querySelector('.rv__list');
      var shown = 0;
      items.forEach(function (p) {
        if (!p) return;
        var li = document.createElement('li'); li.className = 'rv__item';
        var a = document.createElement('a'); a.href = p.url; a.className = 'rv__link';
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2'); img.alt = p.title; img.loading = 'lazy'; img.width = 200; img.height = 260;
          a.appendChild(img);
        }
        var t = document.createElement('span'); t.className = 'rv__title'; t.textContent = p.title;
        var pr = document.createElement('span'); pr.className = 'rv__price'; pr.textContent = money(p.price);
        if (p.compare_at_price > p.price) {
          var s = document.createElement('s'); s.textContent = money(p.compare_at_price);
          pr.appendChild(document.createTextNode(' ')); pr.appendChild(s);
        }
        a.appendChild(t); a.appendChild(pr); li.appendChild(a);
        var v = p.variants && p.variants[0];
        if (p.variants && p.variants.length === 1 && v && v.available) {
          var add = document.createElement('button');
          add.type = 'button'; add.className = 'rv__add'; add.setAttribute('data-upsell-add', ''); add.setAttribute('data-variant-id', v.id);
          add.textContent = '+ Add to cart'; li.appendChild(add);
        }
        ul.appendChild(li); shown++;
      });
      if (shown) box.hidden = false;
    });
  }

  function boot() { document.querySelectorAll('[data-recently-viewed]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
